/** База API без завершающего слэша. По умолчанию относительный `/api/v1` (прокси Vite / тот же origin). */
export function getApiBaseUrl(): string {
  const w = window as unknown as Record<string, string | undefined>;
  if (w.DOMCRM_API_BASE) {
    return w.DOMCRM_API_BASE.replace(/\/+$/, '');
  }
  const raw = import.meta.env.VITE_API_BASE_URL ?? '/api/v1';
  return raw.replace(/\/+$/, '');
}
